<template>
  <div>
    <v-btn @click="selectDescendant(index)" v-for="(descendant, index) in descendants" :key="index" x-small>
      <v-icon :color="iconColor(index)" x-small>mdi-server-network</v-icon>
      <!--span class="btn-text">{{ descendant.id }}</span-->
      <span class="btn-text">{{ descendant.shortAlias }}</span>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    storeName: {
      type: String,
      required: true,
    },
    singleSelect: {
      type: Boolean,
      descendants: false,
    },
  },
  computed: {
    descendants() {
      return this.$store.getters[`${this.storeName}/get`];
    },
  },
  methods: {
    iconColor(index) {
      // BEGIN::Modified.by.KWShin.2024.02.14.
      // 기본색이 아니라 인스턴스 색상으로 표시되도록 수정.
      // return this.descendants[index].active ? 'orange darken-2' : 'grey darken-2';
      return this.descendants[index].active ? this.descendants[index].color : 'grey darken-2';
      // FINISH::Modified.by.KWShin.2024.02.14.
    },
    selectDescendant(index) {
      // singleSelect : descendants 중에 한가지만 선택되도록 하는 옵션
      // java stack 일 경우 node 선택은 한가지만 선택되도록 한다.
      // abap stack 일 경우는 system 내의 instance 들이 한꺼번에 선택되도록 하여 정보를 표시한다.
      if (this.singleSelect) {
        if (this.descendants.length == 1) return;
        else {
          this.descendants.forEach((d, seq) => {
            if (index == seq) d.active = true;
            else d.active = false;
          });
        }
      } else {
        if (this.descendants[index].active) {
          const allActive = this.descendants.every(d => d.active);
          if (allActive) this.descendants.forEach((d, seq) => (d.active = index == seq));
          else this.descendants.forEach(d => (d.active = true));
        } else {
          this.descendants.forEach((d, seq) => (d.active = index == seq));
        }
      }
    },
  },
};
</script>

<style scoped>
.btn-text {
  margin: 0 0 2px 5px;
}
</style>
